import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function TransformationSection() {
  const points = ['Pasar de no poder correr 2 minutos… a completar 5K', 'Dejar de empezar y abandonar', 'Tener una rutina que realmente sostenés', 'Sentirte con más energía y confianza', 'Cumplir algo que antes parecía imposible'];
  return <section className="bg-white py-20 md:py-32" data-id="element-253">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-254">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-id="element-255">
          {/* Image */}
          <div className="w-full lg:w-1/2" data-id="element-256">
            <FadeIn direction="right" data-id="element-257">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-square md:aspect-[4/3] lg:aspect-square" data-id="element-258">
                <img src="https://images.unsplash.com/photo-1530549387789-4c1017266635?auto=format&fit=crop&w=1000&q=80" alt="Corredor feliz celebrando" className="w-full h-full object-cover" data-id="element-259" />
                <div className="absolute inset-0 bg-gradient-to-t from-dark/60 via-transparent to-transparent" data-id="element-260"></div>
                <div className="absolute bottom-6 left-6 right-6" data-id="element-261">
                  <div className="bg-white p-4 rounded-xl shadow-lg flex items-center gap-4" data-id="element-262">
                    <div className="bg-success/20 p-2 rounded-full" data-id="element-263">
                      <CheckCircle2 className="w-8 h-8 text-success" data-id="element-264" />
                    </div>
                    <div data-id="element-265">
                      <p className="font-bold text-dark" data-id="element-266">¡Objetivo Cumplido!</p>
                      <p className="text-sm text-gray-600" data-id="element-267">
                        Semana 8 completada
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>

          {/* Text Content */}
          <div className="w-full lg:w-1/2" data-id="element-268">
            <FadeIn data-id="element-269">
              <div className="inline-block px-4 py-1.5 bg-green-100 text-green-700 font-bold rounded-full text-sm mb-6 uppercase tracking-wider" data-id="element-270">
                La Solución
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-dark mb-8" data-id="element-271">
                Imaginate esto en solo{' '}
                <span className="text-primary" data-id="element-272">8 semanas:</span>
              </h2>
            </FadeIn>

            <div className="space-y-4 mb-10" data-id="element-273">
              {points.map((point, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-274">
                  <div className="flex items-start gap-4" data-id="element-275">
                    <CheckCircle2 className="w-6 h-6 text-success flex-shrink-0 mt-1" data-id="element-276" />
                    <p className="text-lg text-gray-700 font-medium" data-id="element-277">{point}</p>
                  </div>
                </FadeIn>)}
            </div>

            <FadeIn delay={0.5} data-id="element-278">
              <div className="border-l-4 border-primary pl-6 py-2" data-id="element-279">
                <p className="text-xl md:text-2xl font-bold text-dark" data-id="element-280">
                  No es solo correr. <br data-id="element-281" />
                  <span className="text-gray-600 font-medium text-lg md:text-xl" data-id="element-282">
                    Es demostrarte que podés sostener lo que empezás.
                  </span>
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}